import { type CommunityDetail, getCommunityDetailQueryKey } from '@pba/react-network';
import { type UseQueryResult, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { getProfileQueryKey } from 'features/users';

type P = {
  communityId: string;
  invitationToken: string;
  queryResult: Pick<UseQueryResult<CommunityDetail>, 'data' | 'isError'>;
};

// TODO: Once the queries invalidated here are moved to @pba/react-network, perform these invalidations directly in useCommunityQuery.
const CommunityInvitationTokenQueryInvalidation = ({
  communityId,
  invitationToken,
  queryResult: { data, isError },
}: P) => {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (isError) {
      void queryClient.invalidateQueries({
        queryKey: getCommunityDetailQueryKey({ id: communityId }),
      });
    }
  }, [queryClient, isError, communityId, invitationToken]);

  useEffect(() => {
    if (data) {
      queryClient.setQueryData(getCommunityDetailQueryKey({ id: data.id }), data);
      void queryClient.invalidateQueries({ queryKey: getProfileQueryKey() });
    }
  }, [queryClient, invitationToken, data]);

  return null;
};

export default CommunityInvitationTokenQueryInvalidation;
